import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Button,
  Col,
  Image,
  Row,
  Typography,
  Divider,
  DatePicker,
  Popover,
  Menu,
  Select,
  Modal,
  Spin,
  Tooltip,
  Space,
  Form,
  Badge,
  message,
  Table,
} from "../../common/utils/antd-imports/AntdImports";
import "antd/dist/reset.css";
import "./ProductModalPopUp.css";
import Paragraph from "antd/es/typography/Paragraph";
import FloatingInput from "../../common/float-input/FloatInput";
import dayjs from "dayjs";
import { API_BASE_URL_IMAGE } from "../../../services/common";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getUserSavedCampaigns,
  createNewCampaign,
  checkProductAvailabilityQuantity,
  checkProductAvailabilityQuantityBeforeLogin,
  productExpiryNotify,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import enUS from "antd/es/date-picker/locale/en_US";
import moment from "moment-timezone";
import { ReactComponent as SelectUpIcon } from "../../../assests/select-up-icon.svg";
import { ReactComponent as SelectDownIcon } from "../../../assests/select-down-icon.svg";
import {
  getSingleProductDetails,
  getSingleProductDetailsBeforeLogin,
} from "../../../store/thunks/common-thunks/commonThunk";
import { RESET_SINGLE_PRODUCT } from "../../../store/slices/common-slice/products/ProductSlice";
import LoginAlert from "../login-alert/LoginAlert";
import GoogleMapsComponent from "../../common/map-view/GoogleMapsComponent";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import FormItem from "antd/es/form/FormItem";
import {
  formatToUSCurrency,
  formatBillboardSize,
  handleCopy,
  formatLocation,
} from "../../common/utils/Utils";
import { ReactComponent as NotifyIcon } from "../../../assests/notify-icon.svg";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { CopyOutlined } from "@ant-design/icons";
import dummyImage from "../../../assests/images/no-image.png";
import { setIsProductPopUp } from "../../../store/slices/common-slice/product-details-action-items/productDetailsActionItemslice";

const { Text } = Typography;
const { RangePicker } = DatePicker;
dayjs.extend(isSameOrBefore);

const formatProductDate = (timestamp) => {
  return timestamp ? dayjs(Number(timestamp)) : null;
};
const ProductModalPopUp = ({
  setSelectedProduct,
  open,
  productId,
  contentName,
  isBillBoard,
  isCampaignsPage,
  productFromDate,
  productToDate,
}) => {
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("user"))?.user;
  const datePickerRef = useRef(null);
  const [showCreateCampaign, setShowCreateCampaign] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaignId, setCampaignId] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedDatesForCampaign, setSelectedDatesForCampaign] = useState([]);
  const [calendarState, setCalendarState] = useState();
  const [campaignName, setCampaignName] = useState("");
  const [isNewcampaign, setIsNewCampaign] = useState(false);
  const [product, setProduct] = useState();
  const images = product?.image;
  const [activeImage, setActiveImage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const fromProductDate = productFromDate
    ? dayjs(productFromDate)
    : formatProductDate(product?.from_date?.$date?.$numberLong);
  const toProductDate = productToDate
    ? dayjs(productToDate)
    : formatProductDate(product?.to_date?.$date?.$numberLong);
  const [form] = Form.useForm();
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const { isProductPopUp } = useSelector((state) => state.productDetailsSlice);
  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);
  const [campaignDetails, setCampaignDetails] = useState({});
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [totalPrice, setTotalPrice] = useState();
  const {
    savedCampaigns,
    isLoading: buyerCampaignsLoader,
    productAvailabilityQuantity,
  } = useSelector((state) => state.buyerCampaigns);
  const { singleProduct, isLoading: productsLoader } = useSelector(
    (state) => state.products,
  );
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  const isLoading = buyerCampaignsLoader || productsLoader;
  const selectedCampaignId = localStorage.getItem("campaignId");
  const selectedCampaignName = localStorage.getItem("CampaignName");
  const campaignFlag = localStorage.getItem("campaignFlag");
  const [panelMonth, setPanelMonth] = useState(dayjs());
  const [showMap, setShowMap] = useState(false);
  const navigate = useNavigate();
  // Disabling the respective dates
  const disableProductDates = (current) => {
    const yesterday = dayjs().subtract(0, "day").startOf("day");
    if (!current) {
      return false;
    }
    // Disable previous dates
    if (current.isBefore(yesterday, "day")) {
      return true;
    }
    // Overall product range restriction
    if (
      (fromProductDate && current.isBefore(dayjs(fromProductDate), "day")) ||
      (toProductDate && current.isAfter(dayjs(toProductDate), "day"))
    ) {
      return true;
    }
    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    // Check if current date belongs
    // to any available slot
    const isWithinAnySlot = fromDates?.some((from, index) => {
      const startDate = dayjs(Number(from?.$date?.$numberLong));
      const endDate = dayjs(Number(toDates?.[index]?.$date?.$numberLong));
      return (
        current?.isSame(startDate, "day") ||
        current?.isSame(endDate, "day") ||
        (current?.isAfter(startDate, "day") &&
          current?.isBefore(endDate, "day"))
      );
    });

    // disable remaining dates
    return !isWithinAnySlot;
  };
  const userType = JSON.parse(localStorage.getItem("user"))?.user?.user_type;
  const disableProductDatesForRangepicker = (current) => {
    if (!product?.area_time_zone_type) return true;
    const timeZone = product?.area_time_zone_type;
    const todayInTZ = moment().tz(timeZone).startOf("day");
    return (
      current &&
      (current.isBefore(todayInTZ, "day") ||
        current.isBefore(fromProductDate, "day") ||
        current.isAfter(toProductDate, "day"))
    );
  };

  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };
  const [productLocations, setProductLocations] = useState({});
  const goToSubPage = () => {
    dispatch(
      addBreadcrumb({
        title: campaignFlag == 1 ? selectedCampaignName : "Campaigns",
        path:
          campaignFlag == 1
            ? `/buyer/campaigndetails?_id=${btoa(selectedCampaignId)}`
            : "/buyer/mycampaigns",
      }),
    );

    if (campaignFlag == 1) {
      navigate(`/buyer/campaigndetails?_id=${btoa(selectedCampaignId)}`);
      localStorage.setItem("campaignFlag", 0);
    } else {
      navigate("/buyer/mycampaigns");
      localStorage.setItem("campaignFlag", 0);
    }
  };
  const handleAddCampaign = async () => {
    try {
      const activeCampaignId = campaignId || selectedCampaignId;
      const payload =
        activeCampaignId?.length && !isNewcampaign
          ? {
              type: "existing",
              product_id: product?.id,
              dates: selectedCampaignDates || [],
              campaign_id: activeCampaignId,
              quantity: 1,
            }
          : campaignDetails;
      await dispatch(createNewCampaign(payload))
        .unwrap()
        .then(() => {
          goToSubPage();
          dispatch(setIsProductPopUp(false));
        });
      // navigate("/buyer/mycampaigns");

      localStorage.removeItem("campaignId");
      localStorage.removeItem("CampaignName");
      localStorage.removeItem();
      setSelectedCampaign(null);
      setCampaignName("");
      setDrawerVisible(false);
      setSelectedDates([]);
    } catch (error) {}
  };

  const getAddtoCampaignDisabled = () => {
    if (
      !((isLoggedIn && selectedCampaign) || selectedCampaignName) ||
      startDate - endDate == 0
    )
      return true;
    else return false;
  };

  const handleNotifyApi = (values) => {
    const payload = {
      loggedinUser: {
        clientId: null,
        email: userDetails?.email,
        firstName: userDetails?.firstName,
        lastName: userDetails?.lastName,
        user_id: userDetails?.user_id,
        user_role: userDetails?.user_role,
        user_type: userDetails?.user_type,
      },
      product_id: product?.id,
      user_message: values?.user_message,
    };
    dispatch(productExpiryNotify(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        form.resetFields();
        dispatch(setIsProductPopUp(false));
      }
    });
  };

  useEffect(() => {
    localStorage.setItem("isProductPopUp", calendarState);
    setCalendarState(isProductPopUp);
    if (isProductPopUp) {
    }
  }, [isProductPopUp]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (isProductPopUp && token && productId) {
      dispatch(getSingleProductDetails(productId));
    } else if (isProductPopUp && !token && productId) {
      dispatch(getSingleProductDetailsBeforeLogin(productId));
    }
  }, [dispatch, isProductPopUp, productId]);

  useEffect(() => {
    if (product?.image) {
      product?.insert_type ?? setActiveImage(product?.image[0]);
    }
  }, [product]);

  useEffect(() => {
    setProduct(singleProduct?.product_details);
  }, [singleProduct]);
  const getDateValues = (dateField) => {
    if (Array.isArray(dateField)) {
      return dateField;
    }

    return dateField ? [dateField] : [];
  };
  const tableColumns = [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital"
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];
  const totalDays = useMemo(() => {
    if (!product) return 0;
    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    return fromDates.reduce((acc, from, index) => {
      const start = dayjs(Number(from?.$date?.$numberLong));
      const end = dayjs(Number(toDates?.[index]?.$date?.$numberLong));

      return acc + end.diff(start, "day") + 1;
    }, 0);
  }, [product]);
  const tableData = React.useMemo(() => {
    if (!product) return [];
    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const quantities = product?.unitQty || [];
    return fromDates.map((from, index) => {
      const startDate = dayjs(Number(from?.$date?.$numberLong)).format(
        "MMM DD, YYYY",
      );
      const endDate = dayjs(
        Number(toDates?.[index]?.$date?.$numberLong),
      )?.format("MMM DD, YYYY");
      return {
        key: index,
        startDate,
        endDate,
        quantity: product?.type === "Digital" ? quantities[index] || "-" : "-",
      };
    });
  }, [product]);
  useEffect(() => {
    if (isCampaignsPage) {
      setSelectedCampaign(campaignName);
    } else {
      setSelectedCampaign(null);
    }
  }, [isCampaignsPage]);
  const handleThumbnailClick = (img) => {
    if (showMap) {
      setShowMap(false);
    }
    setActiveImage(img);
  };
  const handleCreateCamapaign = () => {
    setIsNewCampaign(true);
    const payload = {
      type: "new",
      name: campaignName,
      product_id: product?.id,
      dates: selectedCampaignDates || [],
      quantity: 1,
    };
    setCampaignDetails(payload);
    setSelectedCampaign(campaignName);
    setDrawerVisible(false);
  };

  const handleMenuItemClick = (campaignId, campaignName) => {
    setCampaignId(campaignId);
    setSelectedCampaign(campaignName);
    setDrawerVisible(false);
  };
  const handleCreateCampaign = () => {
    setShowCreateCampaign(true);
  };
  const handleCloseModal = () => {
    setSelectedDates([]);
    setCalendarState(false);
    dispatch(setIsProductPopUp(false));
    setActiveImage(null);
    setSelectedProduct(null);
    setSelectedDatesForCampaign([]);
    dispatch(RESET_SINGLE_PRODUCT());
  };

  const handleDateSelect = (dates) => {
    if (dates?.length === 2 && dates[0] && dates[1]) {
      const [start, end] = dates;

      if (start.isAfter(end)) {
        setSelectedDates([end, start]);
        setSelectedDatesForCampaign([end, start]);
      } else {
        setSelectedDates([start, end]);
        setSelectedDatesForCampaign([start, end]);
      }
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return ""; // or return "-"
    const date = new Date(parseInt(timestamp, 10));
    if (isNaN(date.getTime())) {
      return "";
    }
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  };

  const handleSelect = (date) => {
    const [start, end] = selectedDates;
    if (!start && !end) {
      setSelectedDates([date, undefined]);
      setSelectedDatesForCampaign([date, undefined]);
      return;
    }
    if (start && !end) {
      if (date.isBefore(start, "day")) {
        setSelectedDates([undefined, undefined]);
        setSelectedDatesForCampaign([undefined, undefined]);
      } else {
        setSelectedDates([start, date]);
        setSelectedDatesForCampaign([start, date]);
      }
      return;
    }

    if (start && end) {
      if (date.isBefore(end, "day")) {
        setSelectedDates([date, undefined]);
        setSelectedDatesForCampaign([date, undefined]);
      } else {
        setSelectedDates([start, date]);
        setSelectedDatesForCampaign([start, date]);
      }
    }
    if (start && end && date.isSame(start, "day") && date.isSame(end, "day")) {
      setSelectedDates([undefined, undefined]);
      setSelectedDatesForCampaign([undefined, undefined]);
      return;
    }
  };

  const sortedDates = [...selectedDatesForCampaign].sort(
    (a, b) => new Date(a) - new Date(b),
  );

  const startDate =
    selectedDatesForCampaign?.length > 0
      ? selectedDatesForCampaign?.[0]?.format("MMM D, YYYY")
      : "";

  const endDate =
    sortedDates?.length > 0
      ? sortedDates?.[sortedDates?.length - 1]?.format("MMM D, YYYY")
      : "";

  const formattedDates = sortedDates?.map((date) => ({
    startDate: dayjs(date)?.startOf("day").toISOString(),
    endDate: dayjs(date).endOf("day").toISOString(),
  }));

  function groupDateRanges(data) {
    const sortedData = data.sort(
      (a, b) => new Date(a.startDate) - new Date(b.startDate),
    );

    let currentGroup = [
      {
        startDate: sortedData[0]?.endDate,
        endDate: sortedData[1]?.endDate,
      },
    ];
    return currentGroup;
  }
  const selectedCampaignDates = groupDateRanges(formattedDates);

  let popoverContent = showCreateCampaign ? (
    <div className="addto-campaign-name-modal">
      <FloatingInput
        className="billboard-input-feild"
        label={<>{`Campaign Name `}</>}
        rules={[
          {
            required: true,
            message: "campaign name  required!",
          },
        ]}
        customStyles={floatingInputStyles}
        value={campaignName}
        onChange={(e) => {
          const title = e.target.value
            ?.replace(/[\\/]/g, "")
            ?.replace(/\s{2,}/g, " ");
          setCampaignName(title);
        }}
      />

      <Button
        type="link"
        className="addto-campaign-save-btn"
        onClick={handleCreateCamapaign}
      >
        Save
      </Button>
      <Divider className="add-campaign-name-divider" />
      <div className="go-back-parent">
        <Button
          type="link"
          onClick={() => {
            setShowCreateCampaign(false);
            setIsNewCampaign(false);
          }}
          className="addto-campaign-goback-btn"
        >
          Go Back
        </Button>
      </div>
    </div>
  ) : (
    <div className="dropdown-main-menu" style={{ position: "sticky" }}>
      {isLoading ? (
        <>
          <Spin size="large" fullscreen />
        </>
      ) : (
        <>
          <Menu className="dropdown-main-menu">
            <div className="user-campaign-list">
              {savedCampaigns !== null && savedCampaigns?.length > 0 ? (
                savedCampaigns?.map((campaign, index) => (
                  <Tooltip
                    title={`${campaign?.name} (${campaign?.cid})`}
                    placement="top"
                    overlayClassName="campaign-tooltip"
                  >
                    <Menu.Item
                      key={index}
                      className="dropdown-main-menu-items"
                      onClick={() =>
                        handleMenuItemClick(campaign?.id, campaign?.name)
                      }
                    >
                      {campaign?.name} ({campaign?.cid})
                    </Menu.Item>
                  </Tooltip>
                ))
              ) : (
                <Menu.Item
                  className="common-css"
                  style={{
                    alignItems: "center",
                  }}
                >
                  <>
                    <Row justify="center" align="middle">
                      <span className="product-model-menu-empty">
                        No Campaigns Found
                      </span>
                    </Row>
                  </>
                </Menu.Item>
              )}
            </div>
            <div>
              <Divider />
            </div>
            <Menu.Item
              key="2"
              className="dropdown-main-menu-create-campaign-btn"
            >
              <Row justify="center" align="middle">
                <div className="create-new-campaign-btn-parent">
                  <Button
                    type="link"
                    onClick={handleCreateCampaign}
                    className="dropdown-main-menu-btn"
                  >
                    <span className="create-campaign-btn">
                      Create New Campaign
                    </span>
                  </Button>
                </div>
              </Row>
            </Menu.Item>
          </Menu>
        </>
      )}
    </div>
  );

  const accessToCampaignDrawer = () => {
    if (!isLoggedIn) {
      setLoginPopoverVisible(true);
    } else {
      dispatch(getUserSavedCampaigns());
      setDrawerVisible(!drawerVisible);
    }
  };

  const dateValidation =
    new Date(Number(product?.to_date?.$date?.$numberLong)) <= new Date();

  const minDays = product?.minimumdays || 0;

  const handleCountOfDates = () => {
    const value =
      selectedDatesForCampaign?.length >= 2 &&
      selectedDatesForCampaign[selectedDatesForCampaign?.length - 1]?.diff(
        selectedDatesForCampaign?.[0],
        "day",
      ) +
        1 >=
        minDays
        ? `${
            selectedDatesForCampaign?.[
              selectedDatesForCampaign?.length - 1
            ]?.diff(selectedDatesForCampaign?.[0], "day") + 1
          } `
        : "-";

    return value;
  };

  const calculateTotalPrice = ({
    price,
    productType,
    selectedDays,
    minimumDays,
  }) => {
    const oneDayPrice = price / 28;
    let totalPrice = 0;

    if (productType === "variable") {
      totalPrice =
        Number(selectedDays) >= Number(minimumDays)
          ? Number(selectedDays) * Number(oneDayPrice)
          : Number(minimumDays) * Number(oneDayPrice);
    } else if (productType === "fixed") {
      if (Number(selectedDays) >= Number(minimumDays)) {
        const roundFactor = Math.ceil(
          Number(selectedDays) / Number(minimumDays),
        );
        // Round up to next whole
        const totalDays = roundFactor * Number(minimumDays);
        totalPrice = totalDays * Number(oneDayPrice);
      } else {
        totalPrice = Number(minimumDays) * Number(oneDayPrice);
      }
    }

    return totalPrice; // Optional: Round to nearest integer
  };

  useEffect(() => {
    handleCountOfDates();
    const productdetails = {
      price: product?.default_price || 0, // valid number
      productType: product?.fix?.toLowerCase(), // 'fixed' or 'variable'
      selectedDays: handleCountOfDates(), // valid number
      minimumDays: product?.minimumdays || 0, // valid number
    };
    let v = calculateTotalPrice(productdetails);
    setTotalPrice(v);
  }, [selectedDates, product]);

  useEffect(() => {
    if (selectedDates[0]) {
      setPanelMonth(selectedDates[0]);
    }
  }, [selectedDates]);

  const dateRender = (current, today) => {
    const isSameMonth =
      current.month() === (panelMonth?.month?.() ?? current.month());

    if (disableProductDatesForRangepicker(current)) {
      return <div className="custom-cell disabled">{current.date()}</div>;
    }
    const [start, end] = selectedDates;
    const isStart = start && current.isSame(start, "day");
    const isEnd = end && current.isSame(end, "day");
    const className = [
      "custom-cell",
      isStart && isSameMonth && "start-date",
      isEnd && isSameMonth && "end-date",
    ]
      ?.join(" ")
      ?.trim();
    return (
      <div className={className} onClick={() => handleSelect(current)}>
        {current.date()}
      </div>
    );
  };
  useEffect(() => {
    if (
      selectedDatesForCampaign &&
      selectedDatesForCampaign.length > 0 &&
      selectedDatesForCampaign.every(Boolean)
    ) {
      const payload = {
        productId: product?.id,
        dates: `${selectedDatesForCampaign[0]?.format(
          "YYYY-MM-DD",
        )}/${selectedDatesForCampaign[1]?.format("YYYY-MM-DD")}`,
      };
      const token = localStorage.getItem("token");
      if (token) {
        dispatch(checkProductAvailabilityQuantity(payload));
      } else {
        dispatch(checkProductAvailabilityQuantityBeforeLogin(payload));
      }
    }
  }, [selectedDatesForCampaign]);

  useEffect(() => {
    if (isProductPopUp && product) {
      const lat = parseFloat(product?.lat);
      const lng = parseFloat(product?.lng);
      const title = product?.title;
      const productId = product?.id;

      if (!isNaN(lat) && !isNaN(lng)) {
        setProductLocations({
          lat,
          lng,
          title,
          productId,
        });
      }
    }
  }, [isProductPopUp, product]);
  // Calculating the min and max dates
  const fromDates = getDateValues(product?.from_date);
  const toDates = getDateValues(product?.to_date);
  const fromTimestamps = fromDates?.map((date) =>
    Number(date?.$date?.$numberLong),
  );
  const toTimestamps = toDates?.map((date) => Number(date?.$date?.$numberLong));
  const minFromDate = formatDate(Math?.min(...fromTimestamps));
  const maxToDate = formatDate(Math?.max(...toTimestamps));
  return (
    <>
      <Modal
        title={
          <>
            <div className="checkboard-availability-heading">
              <span>{contentName}</span>{" "}
              <div style={{ paddingLeft: 18 }}>
                {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                  new Date() && (
                  <Badge className="notify-badge" count={"Not Available"} />
                )}
              </div>
            </div>
          </>
        }
        centered
        open={isProductPopUp}
        onCancel={handleCloseModal}
        footer={null}
        className="modal-style"
        width="85%"
        maskClosable={false}
      >
        <div>
          <Divider className="divider-line" />
        </div>

        <div className="product-modal-container">
          <div className="product-container">
            <div className="product-image-container">
              <div className="main-product-img">
                {showMap ? (
                  <GoogleMapsComponent
                    className="google-map-container"
                    isProductModal={true}
                    productLocations={productLocations}
                  />
                ) : product?.insert_type &&
                  product?.insert_type !== "Bulk_state" ? (
                  <Image
                    src={activeImage ? activeImage : product?.image[0]}
                    preview={false}
                    alt=""
                  />
                ) : product?.image && product?.image?.[0] ? (
                  <>
                    <Image
                      src={`${API_BASE_URL_IMAGE}${
                        activeImage ? activeImage : product?.image?.[0]
                      }`}
                      preview={false}
                      alt="product-image"
                    />
                  </>
                ) : (
                  <>
                    <Image
                      src={activeImage ? activeImage : dummyImage}
                      preview={false}
                      alt="product-image"
                    />
                  </>
                )}
              </div>
              {images?.length > 0 && (
                <Row className="image-thumbnail-row">
                  {product?.insert_type && product?.insert_type !== "Bulk_state"
                    ? images?.map((img, index) => (
                        <Image
                          key={index}
                          preview={false}
                          src={img}
                          alt={`thumbnail - ${index + 1}`}
                          className={`thumbnail-img ${
                            activeImage === img ? "active-thumbnail" : ""
                          }`}
                          onClick={() => handleThumbnailClick(img)}
                        />
                      ))
                    : images?.map((img, index) => (
                        <Image
                          key={index}
                          preview={false}
                          src={`${API_BASE_URL_IMAGE}` + img}
                          alt={`thumbnail - ${index + 1}`}
                          className={`thumbnail-img ${
                            activeImage === `${img}` ? "active-thumbnail" : ""
                          }`}
                          onClick={() => handleThumbnailClick(img)}
                        />
                      ))}

                  {product?.map_image &&
                    product?.map_image?.map((image) => (
                      <Image
                        preview={false}
                        src={`${API_BASE_URL_IMAGE}` + image}
                        className={`thumbnail-img ${
                          activeImage === `${API_BASE_URL_IMAGE}${image}`
                            ? "active-thumbnail"
                            : ""
                        }`}
                        alt="map-thumbnail"
                        onClick={() => {
                          setActiveImage(`${API_BASE_URL_IMAGE}${image}`);
                          setShowMap(true);
                        }}
                      />
                    ))}
                </Row>
              )}
            </div>
            <div className="time-square-billboard">
              <span className="product-copy-text-field">
                <span className="billboard-product-id">{product?.siteNo}</span>
                <CopyOutlined
                  onClick={(e) => {
                    e.stopPropagation(); // prevent tooltip close
                    handleCopy(product?.title);
                  }}
                  className="copy-icon"
                />
              </span>
              <div>
                <span className="product-copy-text-field">
                  <span className="billboard-tittle">{product?.title} </span>
                  <CopyOutlined
                    onClick={(e) => {
                      e.stopPropagation(); // prevent tooltip close
                      handleCopy(product?.title);
                    }}
                    className="copy-icon"
                  />
                </span>
              </div>
              <div className="time-square-billboard-table">
                <Row gutter={[16, 16]} className="row-spacing">
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Type</Text>
                      <div className="col-billboard-table-value">
                        {product?.type || "N/A"}
                      </div>
                    </div>
                  </Col>
                  {product?.type !== "Media" && (
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <div className="billboard-item">
                        <Text className="col-heading">Dimensions</Text>
                        <div className="col-billboard-table-value">
                          {formatBillboardSize(product?.height)} X{" "}
                          {formatBillboardSize(product?.width)}
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Address 1</Text>
                      <div className="col-billboard-table-value">
                        {product?.address || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={10}
                    className="view-btn-parent"
                  >
                    <div className="billboard-item">
                      <Text className="col-heading">Address 2</Text>{" "}
                      <div className="col-billboard-table-value">
                        {formatLocation(product)}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">From Date</Text>
                      <div className="col-billboard-table-value">
                        {Array.isArray(product?.from_date)
                          ? minFromDate
                          : formatDate(product?.from_date?.$date?.$numberLong)}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">To Date</Text>
                      <div className="col-billboard-table-value">
                        {Array.isArray(product?.to_date)
                          ? maxToDate
                          : formatDate(product?.to_date?.$date?.$numberLong)}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Seller Id</Text>
                      <div className="col-billboard-table-value">
                        {product?.sellerId || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Audited</Text>
                      <div className="col-billboard-table-value">
                        {product?.audited || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Media HHI</Text>
                      <div className="col-billboard-table-value">
                        {product?.mediahhi || "N/A"}
                      </div>
                    </div>
                  </Col>

                  {product?.type !== "Digital" && product?.unitQty && (
                    <Col span={12} className="product-information-card-col">
                      <Space direction="vertical" size="small">
                        <Text className="product-information-card-label">
                          Unit Qty
                        </Text>
                        <div className="product-information-card-value-div">
                          <Text className="product-information-card-value">
                            {product?.unitQty || "N/A"}
                          </Text>
                        </div>
                      </Space>
                    </Col>
                  )}

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">4-week Price Net Cost</Text>
                      <div className="col-billboard-table-value">
                        {formatToUSCurrency(
                          Number(product?.rateCard)?.toFixed(2),
                        ) || "N/A"}
                      </div>
                    </div>
                  </Col>
                  {userType === "owner" && (
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <div className="billboard-item">
                        <Text className="col-heading">
                          4-week Negotiated Net Cost
                        </Text>
                        <div className="col-billboard-table-value">
                          {formatToUSCurrency(
                            Number(product?.negotiatedCost)?.toFixed(2),
                          ) || "N/A"}
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Install Cost</Text>
                      <div className="col-billboard-table-value">
                        {formatToUSCurrency(
                          Number(product?.installCost)?.toFixed(2),
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Production Cost</Text>
                      <div className="col-billboard-table-value">
                        {formatToUSCurrency(
                          Number(product?.productioncost)?.toFixed(2),
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">AMP Bills</Text>
                      <div className="col-billboard-table-value">
                        {product?.billingYes === ""
                          ? product?.billingNo === ""
                            ? product?.billingYes
                            : product?.billingNo
                          : product?.billingYes}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">AMP Services</Text>
                      <div className="col-billboard-table-value">
                        {product?.servicingYes === ""
                          ? product?.servicingNo === ""
                            ? product?.servicingYes
                            : product?.servicingNo
                          : product?.servicingYes}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Fixed/Variable</Text>
                      <div className="col-billboard-table-value">
                        {product?.fix || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Product Direction</Text>
                      <div className="col-billboard-table-value">
                        {product?.imgdirection || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Impression 18-49</Text>
                      <div className="col-billboard-table-value">
                        {product?.firstImpression || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">CPM A 18-49</Text>
                      <div className="col-billboard-table-value">
                        {product?.firstcpm !== "undefined" &&
                        product?.firstcpm !== ""
                          ? formatToUSCurrency(
                              Number(product?.firstcpm)?.toFixed(2),
                            )
                          : "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Impression 18-Plus</Text>
                      <div className="col-billboard-table-value">
                        {product?.secondImpression || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">CPM A 18-Plus</Text>
                      <div className="col-billboard-table-value">
                        {product?.cpm !== "undefined" && product?.cpm !== ""
                          ? formatToUSCurrency(Number(product?.cpm)?.toFixed(2))
                          : "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Impression 25-54</Text>
                      <div className="col-billboard-table-value">
                        {product?.thirdImpression || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">CPM A 25-54</Text>
                      <div className="col-billboard-table-value">
                        {product?.thirdcpm !== "" &&
                        product?.thirdcpm !== "undefined"
                          ? formatToUSCurrency(
                              Number(product?.thirdcpm)?.toFixed(2),
                            )
                          : "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">
                        Impression (HA25 - HA54)
                      </Text>
                      <div className="col-billboard-table-value">
                        {product?.forthImpression || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">CPM H 25 - 54</Text>
                      <div className="col-billboard-table-value">
                        {product?.forthcpm !== "" &&
                        product?.forthcpm !== "undefined"
                          ? formatToUSCurrency(
                              Number(product?.forthcpm)?.toFixed(2),
                            )
                          : "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Cancellation Policy</Text>
                      <div className="col-billboard-table-value">
                        {product?.cancellation_policy || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Payment Terms</Text>
                      <div className="col-billboard-table-value">
                        {product?.cancellation_terms || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Restrictions</Text>
                      <div className="col-billboard-table-value">
                        {product?.notes || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Facing</Text>
                      <div className="col-billboard-table-value">
                        {product?.direction || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Latitude</Text>
                      <div className="col-billboard-table-value">
                        {product?.lat || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Longitude</Text>
                      <div className="col-billboard-table-value">
                        {product?.lng || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Comments</Text>
                      <div className="col-billboard-table-value">
                        {product?.Comments || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Location Description</Text>
                      <div className="col-billboard-table-value">
                        {product?.locationDesc || "N/A"}
                      </div>
                    </div>
                  </Col>
                  {userType !== "owner" && (
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <div className="billboard-item">
                        <Text className="col-heading">Tax Percentage (%)</Text>
                        <div className="col-billboard-table-value">
                          {product?.tax_percentage || "N/A"}
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">DMA</Text>
                      <div className="col-billboard-table-value">
                        {product?.city || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading"># of 4-week periods</Text>
                      <div className="col-billboard-table-value">
                        {Number(product?.weekPeriod)?.toFixed(2) || "N/A"}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Minimum Days</Text>
                      <div className="col-billboard-table-value">
                        {product?.minimumdays || "N/A"}
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={10}>
                    <div className="billboard-item">
                      <Text className="col-heading">Description</Text>
                      <div className="col-billboard-table-value">
                        {product?.description || "N/A"}
                      </div>
                    </div>
                  </Col>
                  {product?.type !== "Static" && (
                    <>
                      {product?.type === "Digital" ||
                      product?.type === "Media" ? (
                        <Col xs={24} sm={24} md={12} lg={10}>
                          <div className="billboard-item">
                            <Text className="col-heading">Spot Length</Text>
                            <div className="col-billboard-table-value">
                              {product?.spotLength || "N/A"}
                            </div>
                          </div>
                        </Col>
                      ) : (
                        product?.type === "Digital/Static" && (
                          <Col xs={24} sm={24} md={12} lg={10}>
                            <div className="billboard-item">
                              <Text className="col-heading">Flip Length</Text>
                              <div className="col-billboard-table-value">
                                {product?.fliplength || "N/A"}
                              </div>
                            </div>
                          </Col>
                        )
                      )}

                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">
                            {product?.type === "Media"
                              ? "Break / Loop Length "
                              : "Loop Length"}
                          </Text>
                          <div className="col-billboard-table-value">
                            {product?.ageloopLength || "N/A"}
                          </div>
                        </div>
                      </Col>
                    </>
                  )}
                  {product?.type === "Media" && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Genre</Text>
                          <div className="col-billboard-table-value">
                            {product?.genre || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Day Part</Text>
                          <div className="col-billboard-table-value">
                            {product?.daypart || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">File type</Text>
                          <div className="col-billboard-table-value">
                            {product?.file_type || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Network</Text>
                          <div className="col-billboard-table-value">
                            {product?.network || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">National/Local</Text>
                          <div className="col-billboard-table-value">
                            {product?.nationloc || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Ad Type</Text>
                          <div className="col-billboard-table-value">
                            {product?.placement || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Static or Motion</Text>
                          <div className="col-billboard-table-value">
                            {product?.staticOrMotion || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Sound</Text>
                          <div className="col-billboard-table-value">
                            {product?.sound || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Length</Text>
                          <div className="col-billboard-table-value">
                            {product?.length || "N/A"}
                          </div>
                        </div>
                      </Col>
                    </>
                  )}
                  {product?.type !== "Media" && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Height</Text>
                          <div className="col-billboard-table-value">
                            {product?.height || "N/A"}
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={10}>
                        <div className="billboard-item">
                          <Text className="col-heading">Width</Text>
                          <div className="col-billboard-table-value">
                            {product?.width || "N/A"}
                          </div>
                        </div>
                      </Col>
                    </>
                  )}
                  {product?.type === "Static" && (
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <div className="billboard-item">
                        <Text className="col-heading">Illumination</Text>
                        <div className="col-billboard-table-value">
                          {product?.lighting || "N/A"}
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>

            <div className="time-square-billboard-calendar">
              {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
              new Date() ? (
                <div className="notify-section-text">
                  <div className="not-available-text">
                    Opps - This product is currently unavailable. We can contact
                    the seller and see when it will be available in the future.
                    Just tell us what dates are you looking for
                  </div>
                  <div className="book-it-text">Looking to book it soon? </div>
                </div>
              ) : (
                <>
                  {!isBillBoard && (
                    <>
                      <div level={5} className="billboard-calendar-title">
                        <Text className="select-date-text">Select Dates</Text>
                      </div>
                      {selectedDatesForCampaign[
                        selectedDatesForCampaign.length - 1
                      ]?.diff(selectedDatesForCampaign[0], "day") +
                        1 <
                        Number(product?.minimumdays) && (
                        <div className="calendar-message-paragraph">
                          <Text className="calendar-description">
                            Please select a{" "}
                            <Text className="minimum-dates">
                              {product?.minimumdays} days
                            </Text>{" "}
                            to rent this product. Pricing will dynamically
                            adjust based on the selected dates.
                          </Text>
                        </div>
                      )}
                    </>
                  )}

                  <div
                    className="datepicker-container"
                    style={{ position: isLoading && "sticky" }}
                  >
                    {isBillBoard ? (
                      <DatePicker
                        locale={customLocale}
                        className="custom-calendar"
                        popupClassName="custom-calendar-popup"
                        ref={datePickerRef}
                        open={calendarState}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        superNextIcon={false}
                        superPrevIcon={false}
                        placeholder=""
                        multiple
                        value={
                          isBillBoard && userDetails?.user_type == "owner"
                            ? (() => {
                                const fromDates = getDateValues(
                                  product?.from_date,
                                );
                                const toDates = getDateValues(product?.to_date);
                                return fromDates.flatMap((from, index) => {
                                  const startDate = dayjs(
                                    Number(from?.$date?.$numberLong),
                                  );
                                  const endDate = dayjs(
                                    Number(
                                      toDates?.[index]?.$date?.$numberLong,
                                    ),
                                  );
                                  const totalDays =
                                    endDate?.diff(startDate, "day") + 1;
                                  return Array?.from(
                                    { length: totalDays },
                                    (_, i) => startDate?.add(i, "day"),
                                  );
                                });
                              })()
                            : Array.from(
                                {
                                  length:
                                    dayjs(productToDate)?.diff(
                                      dayjs(productFromDate),
                                      "day",
                                    ) + 1,
                                },
                                (_, i) => dayjs(productFromDate)?.add(i, "day"),
                              )
                        }
                        disabledDate={disableProductDates}
                      />
                    ) : (
                      <RangePicker
                        locale={customLocale}
                        className="custom-calendar"
                        popupClassName="custom-calendar-popup custom-calendar-arrows"
                        ref={datePickerRef}
                        open={calendarState}
                        inputReadOnly
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        superNextIcon={false}
                        superPrevIcon={false}
                        format="YYYY-MM-DD"
                        value={selectedDates.length === 2 && selectedDates}
                        onPanelChange={(value) => setPanelMonth(value[0])}
                        dateRender={(current) =>
                          dateRender(current, panelMonth)
                        }
                        onCalendarChange={handleDateSelect}
                        onChange={() => {}}
                        disabledDate={(current) => {
                          if (!product?.area_time_zone_type) return false;
                          const nowUTC = moment().utc();
                          const nowInSelectedTZ = nowUTC
                            .tz(product?.area_time_zone_type)
                            ?.startOf("day");
                          return (
                            current && current?.isBefore(nowInSelectedTZ, "day")
                          );
                        }}
                      />
                    )}
                  </div>

                  <div className="calendar-selected-dates-container">
                    <Text className="selected-days-heading">
                      No.of Days Selected
                    </Text>
                    {!isBillBoard ? (
                      <div>
                        <Text className="total-selected-days">
                          {`${
                            selectedDatesForCampaign?.[
                              selectedDatesForCampaign?.length - 1
                            ]?.diff(selectedDatesForCampaign?.[0], "day") + 1 ||
                            0
                          } Days`}
                          {startDate &&
                            endDate &&
                            `(${startDate} - ${endDate})`}
                        </Text>
                      </div>
                    ) : (
                      <>
                        <div style={{ marginBottom: 16 }}>
                          <Text className="total-selected-days">
                            Total Selected Days : {totalDays} Days
                          </Text>
                        </div>
                        <div className="multi-slot-dates-table">
                          <Table
                            columns={tableColumns}
                            dataSource={tableData}
                            pagination={false}
                            rowKey="key"
                            size="small"
                            className="billboard-table"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {!isBillBoard && (
                    <div className="create-new-campaign-popover">
                      <LoginAlert
                        loginPopoverVisible={loginPopoverVisible}
                        setLoginPopoverVisible={setLoginPopoverVisible}
                      />
                      <div className="campaign-popover">
                        <Popover
                          content={popoverContent}
                          trigger="click"
                          open={drawerVisible}
                          placement="top"
                          overlayClassName="custom-new-campaign-popover"
                          onOpenChange={(visible) => {
                            setDrawerVisible(visible);
                            if (!visible) {
                              setShowCreateCampaign(false);
                            }
                          }}
                        >
                          <div className="select-campaign-div"></div>
                        </Popover>
                      </div>
                      <div
                        style={{ position: "sticky" }}
                        className="select-campaign-div"
                      >
                        <Text className="select-campaign-label">
                          Select the Campaign
                        </Text>
                        <Select
                          disabled={
                            selectedDatesForCampaign[
                              selectedDatesForCampaign.length - 1
                            ]?.diff(selectedDatesForCampaign[0], "day") +
                              1 >=
                              1 && productAvailabilityQuantity >= 1
                              ? false
                              : true
                          }
                          onClick={() => {
                            if (
                              selectedDatesForCampaign[
                                selectedDatesForCampaign.length - 1
                              ]?.diff(selectedDatesForCampaign[0], "day") +
                                1 >=
                                1 &&
                              productAvailabilityQuantity >= 1
                            ) {
                              accessToCampaignDrawer();
                            }
                          }}
                          onDropdownVisibleChange={(open) => setIsOpen(open)}
                          suffixIcon={
                            isOpen ? <SelectUpIcon /> : <SelectDownIcon />
                          }
                          allowClear
                          placeholder="Select the Campaign"
                          className="select-campaign-dropdown"
                          value={
                            isCampaignsPage
                              ? selectedCampaign ||
                                selectedCampaignName ||
                                undefined
                              : selectedCampaign
                          }
                          open={false}
                          showArrow={true}
                          bordered={false}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
              {dateValidation && (
                <Space direction="vertical" size={15}>
                  <Form form={form} onFinish={handleNotifyApi}>
                    <Row>
                      <div className="drop-text-label">
                        Drop us a quick note, and we'll let you know if it
                        becomes available.
                      </div>
                      <FormItem
                        style={{ width: "100%" }}
                        name="user_message"
                        rules={[
                          {
                            required: true,
                            message: "Message is required!",
                          },
                        ]}
                      >
                        <FloatingTextArea
                          customStyles={textAreaFloatingInputStyles}
                          maxLength={500}
                          label={<>{`Message`}</>}
                          className="billboard-input-feild billboard-text-area"
                        ></FloatingTextArea>
                      </FormItem>
                      <Button
                        key={product?.id}
                        className="details-btn billboard-button-2"
                        type="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isLoggedIn) {
                            message.error(
                              "Please login to submit your response.",
                            );
                            setLoginPopoverVisible(true);
                            return;
                          } else {
                            form.submit();
                          }
                        }}
                      >
                        <NotifyIcon style={{ color: "#fff" }} />
                        Notify me
                      </Button>
                    </Row>
                  </Form>
                </Space>
              )}
            </div>
          </div>
          {!isBillBoard && (
            <div className="addto-campain-footer">
              <div className="addto-campain-footer-sub-div">
                {dateValidation ? (
                  <>
                    <Paragraph className="addtocampain-paragraph">
                      (We'll email you when this product becomes available. Do
                      you want to continue?)
                    </Paragraph>
                  </>
                ) : (
                  <>
                    <div className="price-paragraph-container">
                      <Text className="campaign-price">
                        {formatToUSCurrency(
                          parseFloat(
                            selectedDatesForCampaign[
                              selectedDatesForCampaign.length - 1
                            ]?.diff(selectedDatesForCampaign[0], "day") +
                              1 >
                              0
                              ? totalPrice
                              : 0 || 0,
                          ).toFixed(2),
                        )}
                      </Text>
                      <Paragraph className="addtocampain-paragraph">
                        (Includes all taxes, installation fees, and
                        manufacturing costs for the selected days)
                      </Paragraph>
                    </div>
                  </>
                )}
                <Button
                  type="primary"
                  className={`addto-campain-btn ${
                    !isLoggedIn ? "disabled-button" : ""
                  } ${getAddtoCampaignDisabled() ? "disable-add-tocart" : ""}`}
                  disabled={
                    getAddtoCampaignDisabled() ||
                    new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                      new Date()
                  }
                  onClick={handleAddCampaign}
                >
                  Add to Campaign
                </Button>
              </div>
            </div>
          )}
        </div>
        {isLoading && (
          <div className="product-modal-spin">
            <Spin size="large" fullscreen />
          </div>
        )}
      </Modal>
    </>
  );
};

export default ProductModalPopUp;
